// extracted by css-extract-rspack-plugin
export default {"contentContainer":"contentContainer-RiTZXL","dataBuilderContainer":"dataBuilderContainer-MyTu5z"};